(function (window, $, app) {
    app.init();
    
    app.$doc = $(window.document);
    app.$body = $('body');
    
    app.ANIMATION_DURATION = 300;
    app.BOOTSTRAP_BREAKS = {
        sm: 768,
        md: 992,
        lg: 1200
    };
    app.NAV_BREAKPOINT = 832;

    app.bind();
    app.ActionResolver.bindActions();
})(window, jQuery, app);
